import React from 'react'
import styles from './PLPOptionCard.module.sass'
import { MenuItemType } from '@utils/types'
import { WLink } from '@components/atoms'
import he from 'he'

interface Props {
  item?: MenuItemType
  selected?: boolean
  className?: string
}

const PLPOptionCard = (props: Props) => {
  const { item = undefined, selected = false, className = '' } = props

  return selected || !item.url ? (
    <div className={`${styles.root} ${selected ? styles['root--selected'] : ''} ${className}`}>
      {he.decode(item.name)}
    </div>
  ) : (
    <WLink href={item.url} className={`${styles.root} ${className}`}>
      {he.decode(item.name)}
    </WLink>
  )
}

export default PLPOptionCard
